import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { Advantages } from './components/Advantages';
import { FindApartment } from './components/FindApartment';
import { Header } from './components/Header';
import { PlusMinus } from './components/PlusMinus';
import { StickButtons } from './components/StickButtons';
import * as styles from './LandingPage.css';

export interface ILandingPageProps {
  onCallButtonClick: () => void;
  onRequestButtonClick: () => void;
}

export const LandingPage: React.FC<ILandingPageProps> = ({ onCallButtonClick, onRequestButtonClick }) => {
  const headerButtonsRef = React.useRef<HTMLDivElement>(null);
  const footerButtonsRef = React.useRef<HTMLDivElement>(null);

  return (
    <div className={styles['page']} data-testid="LandingPage">
      <Header
        buttonsRef={headerButtonsRef}
        onCallButtonClick={onCallButtonClick}
        onRequestButtonClick={onRequestButtonClick}
      />
      <PlusMinus />
      <Advantages />
      <FindApartment
        buttonsRef={footerButtonsRef}
        onCallButtonClick={onCallButtonClick}
        onRequestButtonClick={onRequestButtonClick}
      />
      <Responsive phone>
        <StickButtons
          headerButtonsRef={headerButtonsRef}
          footerButtonsRef={footerButtonsRef}
          onCallButtonClick={onCallButtonClick}
          onRequestButtonClick={onRequestButtonClick}
        />
      </Responsive>
    </div>
  );
};
